import React, { useEffect, useState } from "react";

import "./styles/Home.css";

import politicianData from "./data/politicianData";


import Hero from "./components/Hero";
import ProfileStrip from "./components/ProfileStrip";
import About from "./components/About";
import CurrentOffice from "./components/CurrentOffice";
import CareerTimeline from "./components/CareerTimeline";
import Constituency from "./components/Constituency";
import Impact from "./components/Impact";
import Projects from "./components/Projects";
import VoiceSection from "./components/VoiceSection";
import News from "./components/News";
import Contact from "./components/Contact";

import { usePublicSite } from "./context/PublicSiteContext";


const Home = () => {

     const { siteData, loading, error } = usePublicSite();
    const [menuOpen, setMenuOpen] = useState(false);

    const [scrolled, setScrolled] = useState(false);

    const [darkMode, setDarkMode] = useState(() => {
        try {
            return (
                localStorage.getItem(
                    "akindele-theme"
                ) === "dark"
            );
        } catch {
            return false;
        }
    });

    useEffect(() => {
        document.documentElement.style.colorScheme =
            darkMode ? "dark" : "light";

        try {
            localStorage.setItem(
                "akindele-theme",
                darkMode ? "dark" : "light"
            );
        } catch { }
    }, [darkMode]);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 40);
        };

        window.addEventListener(
            "scroll",
            handleScroll,
            { passive: true }
        );

        return () => {
            window.removeEventListener(
                "scroll",
                handleScroll
            );
        };
    }, []);

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <div
            className={`politician-home ${darkMode
                    ? "dark-mode"
                    : "light-mode"
                }`}
        >

            <a
                className="skip-link"
                href="#main-content"
            >
                Skip to main content
            </a>

            <main id="main-content">

                <Hero data={siteData} />

                <ProfileStrip
                    data={siteData}
                />

                <About
                    data={siteData}
                />

                <CurrentOffice
                    data={siteData}
                />

                <CareerTimeline
                    data={siteData}
                />

                <Constituency
                    data={siteData}
                />

                <Impact
                    data={siteData}
                />

                <Projects
                    scroll={false}
                />

                <VoiceSection
                    data={politicianData}
                />

                <News
                    scroll={false}
                />

                <Contact
                    data={siteData}
                />

            </main>

       

        </div>
    );
};

export default Home;